<template>
  
  <div>
    <el-dialog title="实名认证审核" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form>
        <el-form-item v-if="front_idcard" label="身份证正面" >
          <div class="d-c-c ad-picture">
            <a target="_blank" title="点击查看大图" :href="front_idcard" >
              <img  :src="front_idcard" width="300" height="124" />
            </a>
          </div>
        </el-form-item>
        <el-form-item v-if="back_idcard" label="身份证反面" >
          <div class="d-c-c ad-picture">
            <a target="_blank" title="点击查看大图" :href="back_idcard">
              <img  :src="back_idcard" width="300" height="124" />
            </a>
          </div>
        </el-form-item>
        <el-form-item v-if="business_license" label="营业执照" >
          <div class="d-c-c ad-picture">
            <a target="_blank" title="点击查看大图" :href="business_license">
              <img  :src="business_license" width="300" height="124" />
            </a>
          </div>
        </el-form-item>
      </el-form>
      <el-form :model="form" v-if="status==10">
        <el-form-item label="审核状态" :label-width="formLabelWidth">
          <div>
            <el-radio v-model="form.apply_status" label="20">审核通过</el-radio>
            <el-radio v-model="form.apply_status" label="30">驳回</el-radio>
          </div>
        </el-form-item>
        <div v-if="form.apply_status == 30">
          <el-form-item label="驳回原因" :label-width="formLabelWidth"><el-input v-model="form.reject_reason" autocomplete="off"></el-input></el-form-item>
        </div>
      </el-form>
      <div slot="footer"  v-if="status==10" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="editApplyStatus">确 定</el-button>
      </div>
      <el-form>
        <el-form-item  v-if="status==30" label="驳回原因" >
          <p>{{ reject_reason }}</p>
        </el-form-item>
      </el-form>
      
    </el-dialog>
  </div>
</template>

<script>
import PlusApi from '@/api/plus.js';
export default {
  data() {
    return {
      front_idcard:'',
      back_idcard:'',
      business_license:'',
      status: '',
      reject_reason: '',
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false
    };
  },
  props: ['open_edit', 'form'],
  created() {
    this.dialogVisible = this.open_edit;
    this.status = this.form.apply_status.value;
    this.front_idcard=this.form.front_idcard;
    this.back_idcard=this.form.back_idcard
    this.business_license=this.form.business_license;
    console.log(this.data)
    if (this.status == 30) {
      this.reject_reason = this.form.reject_reason;
    }
  },
  methods: {
    /*修改用户*/
    editApplyStatus() {
      let self = this;
      let params = this.form;
      PlusApi.editCertifyStatus(params, true)
        .then(data => {
          self.$message({
            message: '恭喜你，修改成功',
            type: 'success'
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {});
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/certification/dialog/Edit.vue